<template>
  <div class="main-container">
    <div class="page-top-title">
      <div class="page-top-right">
        <div class="item">
          结算周期：
          <span class="num">{{ settlementDate }}</span>
        </div>
      </div>
    </div>
    <div class="statistics-container">
      <p>汇总数据</p>
      <div class="statistics-item">
        <div class="item">
          保单数：
          <span class="num">{{ statisticsObj.policyNum || 0 }}</span>
          单
        </div>
        <div class="item">
          保费：
          <span class="num">{{ statisticsObj.sumFee || 0 }}</span
          >元
        </div>
        <div class="item">
          费用合计：
          <span class="num">{{ statisticsObj.income || 0 }}</span
          >元
        </div>
        <div class="item">
          首期净收入：
          <span class="num">{{ statisticsObj.firstIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          续期净收入：
          <span class="num">{{ statisticsObj.renewalIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          首年后置费用净收入：
          <span class="num">{{ statisticsObj.postfIncome || 0 }}</span
          >元
        </div>
      </div>
    </div>

    <loading :isShow="listLoading" />
    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detailsPage(row)">保单明细</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />

    <div>
      <Button class="btn" @click="back()">返回</Button>
      <Button class="btn" @click="exportReport">导出报表</Button>
    </div>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
export default {
  mixins: [common, pageTool],
  data() {
    return {
      reportId: null,
      settlementStatus: null,
      reportName: '',
      settlementDate: '',
      statisticsObj: {},
      tableData: [],
      total: 0,
      columns: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 120
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用合计',
          align: 'center',
          key: 'income',
          minWidth: 100
        },
        {
          title: '首期净收入',
          align: 'center',
          key: 'firstIncome',
          minWidth: 100
        },
        {
          title: '续期净收入',
          align: 'center',
          key: 'renewalIncome',
          minWidth: 100
        },
        {
          title: '首年后置费用净收入',
          align: 'center',
          key: 'postfIncome',
          minWidth: 100
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    const { reportId, settlementDate, reportName } = this.$route.query;
    this.reportId = reportId;
    this.reportName = reportName;    
    this.settlementDate = settlementDate;
    this.pageNum = 1;
    this.getList(reportId);
    this.getStatisticsData(reportId);
  },
  methods: {
    // 统计
    getStatisticsData(reportId) {
      this.$http({
        url: '/buz/settlementDetails/statistics',
        type: 'POST',
        data: {
          reportId
        }
      }).then(res => {
        if (res.data) {
          this.statisticsObj = res.data;
        }
      });
    },

    getList(reportId) {
      this.listLoading = true;
      this.$http({
        url: '/buz/settlementDetails/read/page',
        type: 'POST',
        data: {
          reportId,
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 保单明细
    detailsPage(row) {
      this.openPageTabTags('/orgSettlement/commissionSettlement/subordinatePolicyDetails', {
        reportId: this.reportId,
        orgId: row.orgId,
        title: `${row.orgCode}/${row.orgName}${this.settlementDate}基础费用结算明细`
      });
    },

    exportReport() {
      if (!this.$units.pointAction('offline_82_2_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$units.downloadFile('/buz/settlementDetails/export', { reportId: this.reportId }, 'POST');
    }
  }
};
</script>

<style lang="scss" scoped>
.page-top-title {
  font-size: 15px;
  display: flex;
  .title {
    font-size: 16px;
    color: #3c464f;
    font-weight: bold;
  }
  .page-top-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 20px;
    .item {
      color: #515c6f;
      font-size: 14px;
      margin-left: 20px;
    }
    .settlement-status {
      margin-top: 1px;
      margin-left: 20px;
      display: flex;
      .tag-settled {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 2px;
        font-size: 13px;
        color: #e3461f;
        border: 1px solid #ffc1b2;
        background: #fff5f2;
      }
      .tag-be {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        font-size: 13px;
        color: #35bf3f;
        border: 1px solid #abeaae;
        background: #f6fcf4;
      }
    }
  }
}
.statistics-container {
  margin-top: 20px;
  display: flex;
  p {
    white-space: nowrap;
  }
  .statistics-item {
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    color: #333;

    .item {
      font-weight: bold;
      white-space: nowrap;
      margin-bottom: 10px;
      width: 300px;
      .num {
        color: #ff7134;
      }

      .label {
        position: relative;

        .tip-icon {
          margin-right: 2px;
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: transparent;
          border: 1px solid #9c9c9c;
          color: #a8a6a6;
          display: inline-block;
          text-align: center;
          line-height: 14px;
          font-size: 14px;
          cursor: pointer;
          top: 50%;
        }

        .tip-icon:hover + .pop-tip {
          opacity: 0.9;
          z-index: 9999;
          display: block;
        }

        .pop-tip {
          position: absolute;
          width: 250px;
          top: -42px;
          display: flex;
          align-items: center;
          text-align: left;
          left: 50%;
          margin-left: -90px;
          padding: 6px 10px;
          display: flex;
          flex-direction: column;
          background-color: #444444;
          display: none;
          border-radius: 4px;

          span {
            font-size: 12px;
            font-weight: 500;
            color: #fff;
          }

          .arrow {
            position: absolute;
            width: 12px;
            height: 12px;
            background-color: #444444;
            opacity: 0.9;
            bottom: -4px;
            left: 74px;
            transform: rotateZ(135deg);
          }
        }
      }
    }
  }
}
</style>